"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMatches = parseMatches;
function pushToStrArr(strArr, text) {
  var highlighted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (text) {
    strArr.push({ text: text, highlighted: highlighted });
  }
}

function parseMatches(text, matches) {
  if (matches.length === 0) return;

  var splitText = [];
  var indexPairs = matches[0].indices;
  var l = indexPairs.length;

  // Text before any matches
  pushToStrArr(splitText, text.slice(0, indexPairs[0][0]));

  indexPairs.forEach(function (indexPair, i) {
    // Text between matches
    if (i !== 0) {
      var nonHighlightedText = text.slice(indexPairs[i - 1][1] + 1, indexPair[0]);
      pushToStrArr(splitText, nonHighlightedText);
    }
    // Matches text
    var highlightedText = text.slice(indexPair[0], indexPair[1] + 1);
    pushToStrArr(splitText, highlightedText, true);
  });

  // Text after our matches
  pushToStrArr(splitText, text.slice(indexPairs[l - 1][1] + 1, text.length));

  return splitText;
}


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/services/fuzzyMatchParser.js
// module id = 549
// module chunks = 0